import { Navigate, Route, Routes } from 'react-router-dom';
import { AppLayout } from '../layouts/AppLayout';
import { ChatbotsPage } from '../pages/chatbots/ChatbotsPage';
import { ChatbotPage } from '../pages/chatbots/ChatbotPage';
import { ChatbotConversationPage } from '../pages/chatbots/ChatbotConversationPage';
import { TenantDeactivatedPage } from '../pages/errors/TenantDeactivatedPage';
import { GalleryPage } from '../pages/gallery/GalleryPage';
import { KnowledgeDatabasePage } from '../pages/knowledge/KnowledgeDatabasePage';
import { KnowledgePage } from '../pages/knowledge/KnowledgePage';
import { LacTenantDetailsPage } from '../pages/lac/LacTenantDetailsPage';
import { LacPage } from '../pages/lac/LacPage';
import { LacUserProfilePage } from '../pages/lac/LacUserProfilePage';
import { TenantManagementPage } from '../pages/tenants/TenantManagementPage';
import { TenantUserDetailsPage } from '../pages/tenants/TenantUserDetailsPage';
import { PlatformChatPage } from '../pages/platformChat/PlatformChatPage';
import { SettingsPage } from '../pages/settings/SettingsPage';
import {
  ProtectedRoute,
  RequireActiveTenant,
  RequireClientRole,
  RootRedirect,
  TenantAccessNavigationBridge,
} from './guards';
import { TENANT_DEACTIVATED_PATH } from '../query/tenantAccessBlocked';

export function AppRoutes() {
  return (
    <>
      <TenantAccessNavigationBridge />
      <Routes>
        <Route element={<ProtectedRoute />}>
          <Route
            path={TENANT_DEACTIVATED_PATH}
            element={<TenantDeactivatedPage />}
          />
          <Route element={<RequireActiveTenant />}>
            <Route element={<AppLayout />}>
              <Route path="/knowledge" element={<KnowledgePage />} />
              <Route
                path="/knowledge/:databaseId/:tab?"
                element={<KnowledgeDatabasePage />}
              />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/chatbots" element={<ChatbotsPage />} />
              <Route
                path="/chatbots/:chatbotId/conversations/:conversationId"
                element={<ChatbotConversationPage />}
              />
              <Route
                path="/chatbots/:chatbotId/:tab?"
                element={<ChatbotPage />}
              />
              <Route
                path="/platform-chat/:chatId"
                element={<PlatformChatPage />}
              />
              <Route path="/settings/:tab?" element={<SettingsPage />} />
              <Route
                element={<RequireClientRole roles={['ADMIN', 'LAC_ADMIN']} />}
              >
                <Route
                  path="/organisation-management/users/:userId"
                  element={<TenantUserDetailsPage />}
                />
                <Route
                  path="/organisation-management/:tab?"
                  element={<TenantManagementPage />}
                />
              </Route>
              <Route element={<RequireClientRole role="LAC_ADMIN" />}>
                <Route path="/lac/:tab?" element={<LacPage />} />
                <Route
                  path="/lac/users/:tenantName/:userRef"
                  element={<LacUserProfilePage />}
                />
                <Route
                  path="/lac/organisations/:tenantName/:tab?"
                  element={<LacTenantDetailsPage />}
                />
              </Route>
            </Route>
          </Route>
        </Route>

        <Route path="/" element={<RootRedirect />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
